"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("../Themes/styled-components"));
var Wrapper = (0, styled_components_1["default"])('div')(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding: 0 ", ";\n  max-width: ", ";\n  margin: 0 auto;\n  width: 100%;\n  flex: 1 0 0;\n"], ["\n  padding: 0 ", ";\n  max-width: ", ";\n  margin: 0 auto;\n  width: 100%;\n  flex: 1 0 0;\n"])), function (_a) {
    var theme = _a.theme;
    return (0, polished_1.rem)(theme.app.padding);
}, function (_a) {
    var elMaxWidth = _a.elMaxWidth, theme = _a.theme;
    return (0, polished_1.rem)(elMaxWidth || theme.app.maxWidth);
});
var MaxWidthBox = function (_a) {
    var children = _a.children, width = _a.width, className = _a.className;
    return (React.createElement(Wrapper, { className: className, elMaxWidth: width }, children));
};
exports["default"] = MaxWidthBox;
var templateObject_1;
